module.exports = __webpack_public_path__ + "img/logo.920d8ff2.svg";